module.exports = __webpack_public_path__ + "img/checkedLights.ef059298.png";